//initialize
var modelInitializer = new ModelInitializer();
var WithoutPriceModels = modelInitializer.Get("WithoutPriceModels");

//document ready
$(function () {

  var sixSlider = $(".js-six-sliders");
  sixSlider.owlCarousel({
    loop: true,
    margin: 24,
    rtl: true,
    responsiveClass: true,
    autoWidth: false,
    dots: false,
    nav: true,
    // onTranslated: updateOpaqueItems,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
        margin: 16,
      },
      768: {
        items: 4,
        autoWidth: false,
        margin: 16,
      },
      1320: {
        items: 6,

      },
    },
  });



  //best-tours
  var tourSlider = $(".js-best-tours");

  tourSlider.owlCarousel({
    loop: false,
    rtl: true,
    margin: 24,
    nav: true,
    dots: false,
    items: 4,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
        margin: 8,
      },
      768: {
        items: 3,
        autoWidth: false,
      },
      1320: {
        items: 4,
        nav: true,
        margin: 24,
      },
    }
  });

  //users-comments
  $(".js-users-comments").owlCarousel({
    rtl: true,
    items: 1,
    loop: true,
    margin: 0,
  });

  //features
  if ($(window).width() < 992) {
    $(".js-features").owlCarousel({
      rtl: true,
      items: 1,
      loop: true,
      dots: true,
      margin: 0,
    });
  }


  //business logos
  $(".js-business-logos").owlCarousel({

    rtl: true,
    loop: true,
    margin: 0,
    responsive: {
      0: {
        items: 1,
        margin: 50,
        center: true,
        autoWidth: true
      },
      768: {
        items: 3,
        margin: 0,
        autoWidth: false
      },
      992: {
        items: 6,
        margin: 0,
        autoWidth: false
      },
    },
  });

  //hotels slider
  var hotelSlider = $(".js-hotel-slider");
  
  hotelSlider.owlCarousel({
    loop: true,
    rtl: true,
    margin: 24,
    nav: true,
    dots: false,
    items: 4,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
        margin: 12,
      },
      768: {
        items: 3,
        autoWidth: false,
      },
      1320: {
        items: 4,
        nav: true,
        margin: 24,
      },
    }
  });

  // rating
  $(".js-rating").giveScore({
    TotalNum: 5,
    getScore: false,
    setScore: true,
    fontIcon: true,
    htmlelement: false,
    writeScore: false,
    getAndSet: false,
    iclasses: {
      unselect: "icon-empty-star",
      select: "icon-star",
      halfIcon: "icon-half-star"
    },
  });

  if (WithoutPriceModels.items && WithoutPriceModels.items.length) {
    window.getFlightMinimumPrice(WithoutPriceModels.items)
  }
});

//load more airlines 
if (document.body.contains(document.querySelector(".js-toggle-more"))) {

  document.querySelector(".js-toggle-more").addEventListener("click", function toggleCards(e) {
    document.querySelector('.js-card-container').classList.toggle("three-columns__cards-container--show-all");

    e.target.style.display = "none";
  });
}



